<template>
  <div>
    <Breadcrumb :title="'Correction Report'"></Breadcrumb>

    <div class="form-row">
      <BaseSearchBar :config="search" @keyupSearch="filterGrid"></BaseSearchBar>
      <div class="form-group col-md-7" >
        <!-- <label for="kendo-select" style="float:right;" >Correction Type</label> -->
              <div  class="form-group" style="float:right; width:50%" id="kendo-select">
               <kendo-dropdownlist 
                        id="ddlBusinessEvent"
                        v-model="selectedBusinessEvent"
                        :data-source="BusinessEventOptions"
                        :data-text-field="'Option'"
                        @change="onBusinessEventChange"
                        :data-value-field="'Option'">
              </kendo-dropdownlist>
              </div>
      </div>
      
    </div>
    <div class="btnDiv">
      <BaseToolBar :config="toolbarConfig" @buttonClicked="toolbarOnClick"></BaseToolBar>
    </div>
    <div>
      <BaseGrid
        :config="gridConfig"
        :excelExport="excelExport"
        :query="gridConfig.query"
        :mode="'editform'"
				:colorizeColumn=true
        @InfoItem="ShowCorrectionHistory"
        @AttachItem="CorrectionAttachment"
      ></BaseGrid>
    </div>
    <CorrectionDocumentDropoffForm
      ref="correctionDocument"
      :docModalConfig="docModalConfig"
      :filterCondition="filterCondition"
      :transactionRecord="selectedCorrection"
    ></CorrectionDocumentDropoffForm>
  </div>
</template>

<script>
/* eslint-disable vue/consistent-return */
import $ from "jquery";
import {
  //CorrectionEventGridConfig,
  CorrectionReportToolbarConfig,
  IssuanceCorrectionConfig,
  TransferCorrectionConfig,
  VestingCorrectionConfig
} from "./CorrectionReportConfig.js";
import BaseModelCorrection from "@/models/BaseModelCorrection.js";

import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
//import CorrectionForm from "@/components/forms/CorrectionForm.vue";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelDocument from "@/models/BaseModelDocument.js";
import BaseModelCorrectionLog from "@/models/BaseModelCorrectionLog.js";
import { mapGetters, mapActions, mapState } from 'vuex';
import _ from 'lodash';
import { isNullOrUndefined } from 'util';

import CorrectionDocumentDropoffForm from "@/components/forms/CorrectionDocumentDropoffForm.vue";

export default {
  name: "CorrectionEvent",
  mixins: [apiUtil, funcUtil, toolbarUtility],
  computed:{
    ...mapGetters("getModule",["withFilter","GetValueByKey"]),

    gridConfig(){
      switch (this.selectedBusinessEvent) {
        case "Issuance":
          return IssuanceCorrectionConfig
          break;
        case "Transfer":
          return TransferCorrectionConfig
          break;
        case "Vesting":
          return VestingCorrectionConfig
          break; 
        default:
          break;
      }
    }
  },
  components: {
    Breadcrumb,
    BaseGrid,
    BaseSearchBar,
    BaseToolBar,
    CorrectionDocumentDropoffForm
  },
  data: function() {
    return {
      //gridConfig: CorrectionEventGridConfig,
      search: {
        SearchData: ""
      },
      CorrectionGridId: "CorrectionReportGrid",
      CorrectionMasterData: {},
      toolbarConfig: CorrectionReportToolbarConfig,
      BaseModelCorrection: BaseModelCorrection,
      BaseModelUnitClass: BaseModelUnitClass,
      //BaseModelCorrectionLog:BaseModelCorrectionLog,
      // Document dropoff modal
      docModalConfig: {
        modalName: "Correction Documents",
        modalIdandRef: "docModal",
        isFooter: false
      },
      // Filter condition for Document dropoff modal
      filterCondition: {
        filter: "",
        limit: 500
      },
      CorrectionJSON: [],
      selectedCorrection:{},
      BusinessEventOptions:[{"Option":"Issuance"},{"Option":"Transfer"},{"Option":"Vesting"}],
      selectedBusinessEvent:"Issuance"
    };
  },
  methods: {
    ...mapActions("getModule",["AddCollection"]),
    ...mapActions("postModule",['DeleteItem','UpdateAllItems','CreateAllItems']),

    UpdateCorrectionMasterData: function(fromFilter, filterMasterData) {
      if (fromFilter == true) {
        this.CorrectionMasterData = filterMasterData;
      } else {
        this.CorrectionMasterData = JSON.parse(
          JSON.stringify(
            $("#CorrectionReportGrid")
              .data()
              .kendoGrid.dataSource.data()
          )
        );
      }
    },
    toolbarOnClick: function(e) {
      e.preventDefault();
      switch (e.id) {
        case "btnBulkAttachment":
          this.AttachBatchDocuments();
          break;
        // case "btnRefresh":
        // 	this.refreshGrid();
        // 	break;
      }
      this._baseToolBarEvents("CorrectionReportGrid", ...arguments);
    },

    filterGrid: function() {
      let self = this;

      let currentMasterdata = this.CorrectionMasterData;

      let filteredData = this._filterGrid(
        this.CorrectionMasterData,
        this.search.SearchData
      );
      $("#CorrectionReportGrid").data("kendoGrid").dataSource.data(filteredData);
      this.UpdateCorrectionMasterData(true, currentMasterdata);
    },
    ShowCorrectionHistory(e){
      const self = this;
      const grid = $("#" + self.CorrectionGridId).data("kendoGrid");
      const dataItem = grid.dataItem(window.$(e.currentTarget).closest("tr"));

        this.AddCollection({ key: "BusinessEvent", value: dataItem.BusinessEvent });
        this.AddCollection({key: "CorrectionID",value: dataItem.CorrectionID});

        this.$router.push("/report/correctionlog");
    },
    // Correction Documnet Dropoff
    CorrectionAttachment: function(e) {
      let self = this;
      e.preventDefault();
      const gview = window.$("#CorrectionReportGrid").data("kendoGrid");
      const dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));

      this.selectedCorrection={...dataItem};
      
      this.selectedCorrection.TransactionID=dataItem.Id
      this.selectedCorrection.PartnerTitle=dataItem.ReceiverFullName
      this.selectedCorrection.PartnerId=dataItem.ReceiverId

      switch (this.selectedCorrection.BusinessEvent) {
        case "Issuance":
            this.selectedCorrection.CorrectionEventType="Issuance"
          break;
        case "Transfer":
            this.selectedCorrection.CorrectionEventType="Transfer"
          break;
        case "Vesting":
            this.selectedCorrection.CorrectionEventType="Vesting"
          break;  
        default:
          break;
      }

      this.selectedCorrection.BusinessEvent="Correction"

      this.filterCondition.batchQuery=true;

      let BatchGUIDArray=self.GetBatchGUIDArray(this.selectedCorrection.BatchGUID);

      this.filterCondition.filter = function(o){
          return o.BusinessEvent=='Correction' && (o.TransactionID == dataItem.Id || BatchGUIDArray.includes(o.BatchGUID))
      }

      this.$refs.correctionDocument.$refs.correctionDocumentMgr.resetDropZoneGrid();
      window.$("#docModal").modal("toggle");
    },
    AttachBatchDocuments(){

      let selectedItem = [];
      let selectedRowCount=0;

        //Get Next Batch Id
          const result = this.withFilter(BaseModelDocument.list,"");
          let batchId = (result.length <= 0) ? 1 : this._getIncrementalID(result,"BatchGUID");
          //Partner Program Concatenated List Change
          let programIdlist = new Set();
          let partnerIdList = new Set();

          let grid = $("#CorrectionReportGrid").data("kendoGrid");
              grid.select().each(function () {
              selectedRowCount++;
              let selectedDataItem = JSON.parse(JSON.stringify(grid.dataItem(this)));
              let tempBatchId = [];
              if (!isNullOrUndefined(selectedDataItem.BatchGUID) && !selectedDataItem.BatchGUID=="") {
                  tempBatchId = selectedDataItem.BatchGUID.split(",");
              }
              tempBatchId.push(batchId);
              selectedDataItem.BatchGUID = tempBatchId.toString();

              selectedItem.push(selectedDataItem);
              programIdlist.add(selectedDataItem.ProgramId);
              partnerIdList.add(selectedDataItem.ReceiverId);
              (selectedDataItem.SenderId)?partnerIdList.add(selectedDataItem.SenderId):""
              });

          if (selectedRowCount<=1) {
              this._AlertPopup("Please Select Atleast 2 Rows","info");
          }else{
            const batchConfig = {
              Correction: {
               config: this._getBatchGUIDUpdateConfig("Correction"),
               updateData: selectedItem
              }
                };

                this.selectedCorrection={};
                this.selectedCorrection.ProgramId=null
                this.selectedCorrection.PartnerId=null
                this.selectedCorrection.ProgramIdList=[...programIdlist].toString();
                this.selectedCorrection.PartnerIdList=[...partnerIdList].toString();
                this.selectedCorrection.TransactionID=null
                this.selectedCorrection.BusinessEvent="Correction"
                this.selectedCorrection.Type="batch"
                this.selectedCorrection.BatchGUID=batchId;
                this.selectedCorrection.batchConfig=batchConfig
                this.selectedCorrection.parentGridId="CorrectionReportGrid"

                this.filterCondition.batchQuery=false;

                this.filterCondition.filter = `BusinessEvent eq 'Correction' and BatchGUID eq ${
                batchId
            }`;
            
            this.$refs.correctionDocument.$refs.correctionDocumentMgr.resetDropZoneGrid();

            window.$("#docModal").modal("toggle");
                
            }  
        },
    onBusinessEventChange(){
      //alert($("#ddlBusinessEvent").data("kendoDropDownList").text());
      this.selectedBusinessEvent=$("#ddlBusinessEvent").data("kendoDropDownList").text();
    }
  },
  mounted() {
    let self = this;
    //changes for Toolbar
    self.selectedBusinessEvent = (self.GetValueByKey("CorrectionBusinessEvent")) ? self.GetValueByKey("CorrectionBusinessEvent"):"Issuance";
    this.AddCollection({ key: "CorrectionBusinessEvent", value: null });
    self._loadGridSettings(self.CorrectionGridId);

    //bind databound event to grid
    let grid = $("#CorrectionReportGrid").data("kendoGrid");
    grid.bind("dataBound", self.UpdateCorrectionMasterData);
    grid.dataSource.fetch();
  },
};
</script>
<style>
  .RadAutoCompleteBoxPopup{
    float: right !important;
  }
</style>


